export default [
  {
    path: '/recursos-disponiveis',
    name: 'recursos',
    component: () => import(/* webpackChunkName: "recursos" */ '../../views/recursos/Recursos')
  }
]
